import { defaultTheme, Theme } from '../themes'

// eslint-disable-next-line @typescript-eslint/ban-types
const getTheme = (theme: Theme | {}): Theme =>
  Object.entries(theme).length === 0 ? defaultTheme : (theme as Theme)

export default getTheme
